module.exports = __webpack_public_path__ + "img/27.911cba18.png";